var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.calendar
    ? _c("add-to-calendar-button", [
        _vm._v("\n    " + _vm._s(_vm.calendar) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }